import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/tips／check-circle-fill@2x.png'
import _imports_1 from '@/assets/img/weixin.png'
import _imports_2 from '@/assets/img/paySelect.png'
import _imports_3 from '@/assets/img/zhifubao.png'
import _imports_4 from '../../assets/scxx_no.png'


const _hoisted_1 = {
  class: "my_order_checkstand comBox",
  style: {"overflow":"hidden"}
}
const _hoisted_2 = {
  key: 0,
  style: {"width":"8.8rem","margin":"0 auto"}
}
const _hoisted_3 = { class: "payText2" }
const _hoisted_4 = { style: {"color":"#C01A26"} }
const _hoisted_5 = { style: {"margin-bottom":"0.22rem","text-align":"center"} }
const _hoisted_6 = { style: {"font-size":"0.24rem","color":"#C01A26"} }
const _hoisted_7 = { class: "CollectionInformation" }
const _hoisted_8 = { class: "CollectionInformationItem" }
const _hoisted_9 = { class: "CollectionInformationItem" }
const _hoisted_10 = { class: "CollectionInformationItem" }
const _hoisted_11 = { style: {"display":"flex"} }
const _hoisted_12 = {
  key: 0,
  class: "paySelectIcon",
  src: _imports_2
}
const _hoisted_13 = {
  key: 0,
  class: "paySelectIcon",
  src: _imports_2
}
const _hoisted_14 = {
  key: 1,
  style: {"width":"8.8rem","min-height":"4rem","margin":"1rem auto 0"}
}
const _hoisted_15 = { class: "payText2" }
const _hoisted_16 = {
  class: "CollectionInformation",
  style: {"display":"flex","justify-content":"space-between"}
}
const _hoisted_17 = {
  class: "CollectionInformationItem",
  style: {"display":"flex","flex-direction":"column"}
}
const _hoisted_18 = {
  key: 0,
  style: {"color":"#86909C","margin-top":"0.08rem"}
}
const _hoisted_19 = {
  key: 1,
  style: {"color":"#86909C","margin-top":"0.08rem"}
}
const _hoisted_20 = {
  key: 2,
  style: {"color":"#86909C","margin-top":"0.08rem"}
}
const _hoisted_21 = {
  class: "CollectionInformationItem",
  style: {"display":"flex","flex-direction":"column","justify-content":"center"}
}
const _hoisted_22 = { class: "checkstandSuccess" }
const _hoisted_23 = { class: "checkstandSuccessItem" }
const _hoisted_24 = { style: {"color":"#333333"} }
const _hoisted_25 = { class: "checkstandSuccessItem" }
const _hoisted_26 = { style: {"color":"#FF6000","font-size":"0.2rem"} }
const _hoisted_27 = {
  key: 2,
  style: {"width":"8.8rem","min-height":"4rem","margin":"1rem auto 0"}
}
const _hoisted_28 = { class: "payText2" }
const _hoisted_29 = { style: {"text-align":"center","font-size":"0.2rem"} }
const _hoisted_30 = { style: {"text-align":"center","font-size":"0.2rem"} }

import leftTemplate from '@/components/leftTemplate.vue'
import {
	ref,
	computed,
	onMounted
} from 'vue'
import {
	ElMessage,
	ElTable
} from "element-plus";
import {
	Axios
} from "../../assets/js/ls_com_axios.js";

import {
	useRoute,
	useRouter,
} from 'vue-router';
import { log } from 'console';


export default /*@__PURE__*/_defineComponent({
  __name: 'my_order_checkstand',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const totalPay = route.query.totalPay;
const orderIds = route.query.arry;
const orderType = route.query.type;
const authType = route.query.authType;




let status = ref(0); //0 支付中，1 成功  ，2失败
let payType = ref('zfb');

const paySelect = (type) => {

	// if (type == 'wx') {
	// 	ElMessage({
	// 		message: "待开发",
	// 		type: "error",
	// 	});
	// } else {
	// 	payType.value = type;
	// }
	payType.value = type
}


let dialogZfbVisible = ref(false);
let payStatus = ref('');
//15分钟倒计时取消订单
const countdownTime = ref<number>(1800); // 30分钟的秒数
// const countdownTime = ref < number > (2); // 2秒的秒数
const countdown = computed<string>(() => {
	const minutes = Math.floor(countdownTime.value / 60);
	const seconds = countdownTime.value % 60;
	return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
});

const countdownTimefun = ref('')
const startCountdown = () => {
	countdownTimefun.value = setInterval(() => {
		if (countdownTime.value > 0) {
			countdownTime.value--;

		}
		if (countdownTime.value == 0) {
			clearInterval(countdownTimefun.value);
			Axios('post', '/fodder/order/cancel/' + orderDetail.value.id, {}, false, function (res) {
				dialogZfbVisible.value = false;
				status.value = 2;
				ElMessage({
					message: "订单已取消",
					type: "success",
				});
			})
		}
	}, 1000);
};



//支付宝付款状态
const getStatus = (sceneId) => {
	Axios("get", "/pay/pay-status/" + sceneId, false, false, (resp) => {
		if (resp.data.data) {
			dialogZfbVisible.value = false;
			clearInterval(payStatus.value);
			clearInterval(payQrcode.value);
			status.value = 1;
		}
	})
}

//订单详情
let orderDetail = ref({});
const init = () => {
	// .split(',')[0]
	Axios("get", "/fodder/order/info/" + orderIds, false, false, (res) => {

		orderDetail.value = res.data.data[0];
		orderDetail.value.orderNo = res.data.data.map(obj => obj.orderNo).join(",")
		// orderDetail.value.memberName = res.data.data.map(obj => obj.memberName).join(",")
		let tetete = res.data.data.map(obj => { return { "sellerName": obj.sellerName, "sellerId": obj.sellerId } })
		let zhuantete: any = []
		tetete.forEach(el => {
			if (!zhuantete.some(e => e.sellerId == el.sellerId)) {
				zhuantete.push(el);
			}
		});
		console.log('tetete', tetete)
		console.log(zhuantete)
		orderDetail.value.sellerName = zhuantete.map(obj => obj.sellerName).join(",")
		orderDetail.value.title = res.data.data.map(obj => obj.title).join(",")
		orderDetail.value.id = res.data.data.map(obj => obj.id).join(",")
		if (orderDetail.value.status == "1") {
			status.value = 1
		} else if (orderDetail.value.status == "3" || orderDetail.value.status == "2") {
			status.value = 3
		}
		const createTime = new Date(orderDetail.value.createTime).getTime()
		const now = new Date().getTime()
		console.info((now - createTime) / 1000)
		countdownTime.value = 1800 - parseInt((now - createTime) / 1000)
		startCountdown();
	})
}
init();

// 支付宝扫码付款
let payQrcode = ref('');
let qrcode = ref('');
const paySubmit = () => {
	//判断orderType 是购物车支付还是订单支付
	let url:any;
	if(payType.value == 'zfb'){
		url = orderType == 'car' ? '/fodder/car/create-pay/ALIPAY/' : '/fodder/order/create-pay/ALIPAY/'
	}else if(payType.value == 'wx'){
		url = orderType == 'car' ? '/fodder/car/create-pay/WXPAY/' : '/fodder/order/create-pay/WXPAY/'
	}
	createPay(url, 1);
	payQrcode.value = setInterval(() => {
		createPay(url);
	}, 50000)
}
const createPay = (url, num = '') => {
	Axios("post", url + orderIds, false, false, (res) => {
		let data = res.data.data;
		qrcode.value = data.qrcode;
		dialogZfbVisible.value = true;
		if (num == 1) {
			payStatus = setInterval(() => {
				getStatus(data.sceneId);
			}, 2000)
		}

	});
}
//支付宝窗口关闭
const dialogZfbClose = () => {
	dialogZfbVisible.value = false;
	//关闭二维码和支付状态的调用
	clearInterval(payStatus.value);
	clearInterval(payQrcode.value);

}
//重新下订单
const paymentClick = () => {
	console.log(orderDetail)
	Axios("post", "/fodder/order", { materialId: orderDetail.value.materialId, authType: authType }, false, function (res) {
		status.value = 0;
		init();
	});
}
//订单查看
const orderView = () => {
	router.push({
		path: "/myOrder",
	});
}
const materialDown = () => {
	router.push({
		path: "/purchasedMaterial"
	});
}

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[23] || (_cache[23] = _createElementVNode("div", { style: {"font-size":"0.2rem","margin-bottom":"0.2rem","margin-top":"0.2rem"} }, "收银台", -1)),
      (_unref(status) == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _cache[12] || (_cache[12] = _createElementVNode("div", { style: {"width":"0.48rem","height":"0.48rem","margin":"0 auto"} }, [
              _createElementVNode("img", {
                style: {"width":"100%","height":"100%"},
                src: _imports_0
              })
            ], -1)),
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "payText1" }, "订单提交成功，请尽快完成付款!", -1)),
            _createElementVNode("div", _hoisted_3, [
              _createTextVNode("订单号：" + _toDisplayString(_unref(orderDetail).orderNo) + " ", 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(countdown.value), 1),
              _cache[3] || (_cache[3] = _createTextVNode(" 后订单将自动关闭 "))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _cache[4] || (_cache[4] = _createTextVNode("应付金额：")),
              _createElementVNode("span", _hoisted_6, "￥" + _toDisplayString((_unref(totalPay) / 1).toFixed(2)), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[5] || (_cache[5] = _createElementVNode("span", null, "收货人：", -1)),
                _createElementVNode("div", null, _toDisplayString(_unref(orderDetail).memberName), 1)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _cache[6] || (_cache[6] = _createElementVNode("span", null, "收款方：", -1)),
                _createElementVNode("div", null, _toDisplayString(_unref(orderDetail).sellerName), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[7] || (_cache[7] = _createElementVNode("span", null, "商品信息：", -1)),
                _createElementVNode("div", null, _toDisplayString(_unref(orderDetail).title), 1)
              ])
            ]),
            _cache[14] || (_cache[14] = _createElementVNode("div", { style: {"font-size":"0.14rem","margin-bottom":"0.12rem"} }, " 选择支付方式 ", -1)),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: _normalizeClass(["payItem", _unref(payType) == 'wx' ? 'payItemSelect' : '']),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (paySelect('wx')))
              }, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { style: {"width":"0.24rem","height":"0.24rem","margin-right":"0.04rem"} }, [
                  _createElementVNode("img", {
                    style: {"width":"100%","height":"100%"},
                    src: _imports_1
                  })
                ], -1)),
                _cache[9] || (_cache[9] = _createElementVNode("div", null, "微信", -1)),
                (_unref(payType) == 'wx')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_12))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["payItem", _unref(payType) == 'zfb' ? 'payItemSelect' : '']),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (paySelect('zfb')))
              }, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { style: {"width":"0.24rem","height":"0.24rem","margin-right":"0.04rem"} }, [
                  _createElementVNode("img", {
                    style: {"width":"100%","height":"100%"},
                    src: _imports_3
                  })
                ], -1)),
                _cache[11] || (_cache[11] = _createElementVNode("div", null, "支付宝", -1)),
                (_unref(payType) == 'zfb')
                  ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                  : _createCommentVNode("", true)
              ], 2)
            ]),
            _createElementVNode("div", { style: {"display":"flex","justify-content":"center"} }, [
              _createElementVNode("div", {
                class: "bnt",
                onClick: paySubmit
              }, "立即支付")
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(status) == 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _cache[19] || (_cache[19] = _createElementVNode("div", { style: {"width":"0.48rem","height":"0.48rem","margin":"0 auto"} }, [
              _createElementVNode("img", {
                style: {"width":"100%","height":"100%"},
                src: _imports_0
              })
            ], -1)),
            _cache[20] || (_cache[20] = _createElementVNode("div", { class: "payText1" }, "订单支付成功", -1)),
            _createElementVNode("div", _hoisted_15, "您的订单 " + _toDisplayString(_unref(orderDetail).orderNo) + " 已收录至订单列表可随时查看或下载", 1),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", null, _toDisplayString(_unref(orderDetail).title), 1),
                (_unref(orderDetail).authType == 'SELF')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, " 个人授权 "))
                  : _createCommentVNode("", true),
                (_unref(orderDetail).authType == 'ENTERPRISE')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 企业授权 "))
                  : _createCommentVNode("", true),
                (_unref(orderDetail).authType == 'UNION')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, " 联盟授权 "))
                  : _createCommentVNode("", true)
              ]),
              _cache[15] || (_cache[15] = _createElementVNode("div", {
                class: "CollectionInformationItem",
                style: {"display":"flex","flex-direction":"column","justify-content":"center"}
              }, " x1 ", -1)),
              _createElementVNode("div", _hoisted_21, " ￥" + _toDisplayString((_unref(totalPay) / 1).toFixed(2)), 1)
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[16] || (_cache[16] = _createElementVNode("span", null, "商品价格：", -1)),
                _createElementVNode("span", _hoisted_24, "￥" + _toDisplayString((_unref(totalPay) / 1).toFixed(2)), 1)
              ]),
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "checkstandSuccessItem" }, [
                _createElementVNode("span", null, "商品数量："),
                _createElementVNode("span", { style: {"color":"#333333"} }, "x1")
              ], -1)),
              _createElementVNode("div", _hoisted_25, [
                _cache[17] || (_cache[17] = _createElementVNode("span", null, "合计：", -1)),
                _createElementVNode("span", _hoisted_26, "￥" + _toDisplayString((_unref(totalPay) / 1).toFixed(2)), 1)
              ])
            ]),
            _createElementVNode("div", { style: {"display":"flex","justify-content":"center"} }, [
              _createElementVNode("div", {
                class: "bnt",
                onClick: materialDown,
                style: {"width":"1.36rem","margin-right":"0.24rem"}
              }, "下载素材"),
              _createElementVNode("div", {
                class: "bnt",
                onClick: orderView,
                style: {"width":"1.36rem","border":"0.01rem solid #86909C","color":"#333333","background":"transparent"}
              }, "查看订单")
            ])
          ]))
        : _createCommentVNode("", true),
      (_unref(status) == 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _cache[21] || (_cache[21] = _createElementVNode("div", { style: {"width":"0.48rem","height":"0.48rem","margin":"0 auto"} }, [
              _createElementVNode("img", {
                style: {"width":"100%","height":"100%"},
                src: _imports_4
              })
            ], -1)),
            _cache[22] || (_cache[22] = _createElementVNode("div", { class: "payText1" }, "订单已取消", -1)),
            _createElementVNode("div", _hoisted_28, "您的订单 " + _toDisplayString(_unref(orderDetail).orderNo) + " 超时未完成支付", 1),
            _createElementVNode("div", { style: {"display":"flex","justify-content":"center"} }, [
              _createElementVNode("div", {
                class: "bnt",
                style: {"width":"1.36rem"},
                onClick: paymentClick
              }, "重新购买")
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_el_dialog, {
      title: "",
      onClose: dialogZfbClose,
      modelValue: _unref(dialogZfbVisible),
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(dialogZfbVisible) ? (dialogZfbVisible).value = $event : dialogZfbVisible = $event)),
      "align-center": "",
      width: "480px",
      "close-on-click-modal": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "qrcode",
          style: _normalizeStyle('background-image: url(' + _unref(qrcode) + ');')
        }, null, 4),
        _withDirectives(_createElementVNode("div", _hoisted_29, "请用支付宝扫码支付", 512), [
          [_vShow, _unref(payType) == 'zfb']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_30, "请用微信扫码支付", 512), [
          [_vShow, _unref(payType) == 'wx']
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})